import Select, { Props as SelectProps } from "react-select";

type MultiSelectProps = Omit<SelectProps, "isMulti">;

export function MultiSelect(props: MultiSelectProps) {
  return <Select isMulti={true} {...props} />;
}
